import logoLogin from './logoLogin.png';
import logoSidebar from './logoSidebar.png';
import { ReactComponent as LogoSidebar2 } from './logoSidebar.svg';
import logoSidebar2 from './logoSidebar.svg';

export {
  logoLogin,
  logoSidebar, logoSidebar2, LogoSidebar2,
};
